import { render, staticRenderFns } from "./SwitchWrapper.vue?vue&type=template&id=00240896&scoped=true&"
import script from "./SwitchWrapper.vue?vue&type=script&lang=js&"
export * from "./SwitchWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SwitchWrapper.vue?vue&type=style&index=0&id=00240896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00240896",
  null
  
)

export default component.exports